export default __webpack_public_path__ + "static/media/transfer1.cc0ed6ff.png";